import Vue from "vue";
import App from "./App.vue";
import store from "./configurations/store";
import router from "./configurations/router";
import Bootstrap from "bootstrap-vue";
import {
  LayoutPlugin,
  DropdownPlugin,
  TablePlugin,
  ModalPlugin,
  CardPlugin,
  VBScrollspyPlugin,
} from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBell,
  faUser,
  faUsers,
  faChevronLeft,
  faDownload,
  faEnvelope,
  faLock,
  faUserCircle,
  faIdCard,
  faIdBadge,
  faPhone,
  faChartLine,
  faTachometerAlt,
  faSlidersH,
  faChartPie,
  faTasks,
  faFilter,
  faTrash,
  faTimes,
  faArrowLeft,
  faEdit,
  faQuestionCircle,
  faCheck,
  faPencilAlt,
  faVenusMars,
  faSearch,
  faBars,
  faKey,
  faCube,
  faTruck,
  faMapMarker,
  faTty,
  faMoneyBill,
  faRandom,
  faSortNumericDown,
  faPenSquare,
  faClock,
  faCreditCard,
  faArchive,
  faUserPlus,
  faInfo,
  faFlag,
  faShip,
  faCalendar,
  faSquare,
  faList,
  faUniversity,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "bootstrap-vue/dist/bootstrap-vue.css";
import * as VueGoogleMaps from "vue2-google-maps";
import VueSweetalert2 from "vue-sweetalert2";
import vuetify from "./plugins/vuetify";

library.add(
  faBell,
  faUser,
  faUsers,
  faChevronLeft,
  faDownload,
  faEnvelope,
  faLock,
  faUserCircle,
  faIdCard,
  faIdBadge,
  faPhone,
  faChartLine,
  faTachometerAlt,
  faSlidersH,
  faChartPie,
  faTasks,
  faFilter,
  faTrash,
  faTimes,
  faArrowLeft,
  faEdit,
  faQuestionCircle,
  faCheck,
  faPencilAlt,
  faVenusMars,
  faSearch,
  faBars,
  faKey,
  faCube,
  faTruck,
  faMapMarker,
  faTty,
  faMoneyBill,
  faRandom,
  faSortNumericDown,
  faPenSquare,
  faClock,
  faCreditCard,
  faArchive,
  faUserPlus,
  faInfo,
  faFlag,
  faShip,
  faCalendar,
  faSquare,
  faList,
  faUniversity
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(Bootstrap);
Vue.use(DropdownPlugin);
Vue.use(TablePlugin);
Vue.use(VBScrollspyPlugin);
Vue.use(CardPlugin);
Vue.use(ModalPlugin);
Vue.use(LayoutPlugin);
Vue.config.productionTip = false;

const options = {
  confirmButtonColor: "#db0000",
  cancelButtonColor: "#db4753",
};

Vue.use(VueSweetalert2, options);
Vue.use(VueGoogleMaps, {
  installComponents: true,
  load: {
    key: "AIzaSyAD26EvrQW_kIb1DzEre4At-5-iEA5ZVPw",
    v: "3.37",
    libraries: "places",
  },
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
